import { render, staticRenderFns } from "./edu.vue?vue&type=template&id=4f303a42&scoped=true&"
import script from "./edu.vue?vue&type=script&lang=js&"
export * from "./edu.vue?vue&type=script&lang=js&"
import style0 from "./edu.vue?vue&type=style&index=0&id=4f303a42&scoped=true&lang=less&"
import style1 from "./edu.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f303a42",
  null
  
)

export default component.exports